<template>
  <v-layout align-center column>
    <p class="Hero-Text">Laporan Keuangan {{ $route.params.id }}</p>

    <img
      src="../../assets/SyaratKetentuan-Mobile/Hero.png"
      srcset="
        ../../assets/SyaratKetentuan-Mobile/Hero@2x.png 2x,
        ../../assets/SyaratKetentuan-Mobile/Hero@3x.png 3x
      "
      class="Hero"
    />
    <v-col class="pdfContainer mx-auto">
      <v-img
        v-for="i in 10"
        :key="i"
        class="LaporanKeuanganMobile mx-auto"
        :src="
          require('../../assets/InformasiLainnya/' +
            $route.params.id +
            '/report-' +
            i +
            '.jpg')
        "
      />
    </v-col>
  </v-layout>
</template>

<script>
export default {};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin: 0 0 50px;
  object-fit: contain;
}
/* .Hero {
  width: 360px;
  height: 134px;
  margin: 0 0 50px;
  padding: 0 0 16px;
  object-fit: contain;
} */
.Hero-Text {
  /* width: 328px; */
  height: 30px;
  margin: 90px auto;
  font-family: Sora;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
  position: absolute;
}
.pdfContainer {
  margin-top: -25px;
}
.LaporanKeuanganMobile {
  border-style: solid;
  border-width: 2px;
  margin-bottom: 15px;
  max-width: 80vh;
}
</style>
